import React from 'react';
import {
    ATMModal,
    ATMButton,
    ATMForm,
    ATMGrid,
    ATMInput,
    ATMField,
    ATMIcon,
    ORGDataTable,
    IORGDataTableColumn,
    IORGDataTableQueryState,
} from 'shared-it-appmod-ui';
import moment from 'moment-timezone';
import Lang from 'src/libraries/language';
import { concatinateArrayWithSpace } from 'src/components/pages/utils/ArrayUtils';


type Iprops = {
    data: any;
    openAuditLogs: boolean;
    handleClose: () => void;
    loadinglog: boolean;
    fetchLogData: (params: IORGDataTableQueryState) => void;
    totalRecord: number;
    handleOpenEmailView: (data) => void;
};

function InvalidContractsAuditLogView({
    data,
    openAuditLogs,
    handleClose,
    loadinglog,
    fetchLogData,
    totalRecord, handleOpenEmailView
}: Iprops): any {
    const columns: IORGDataTableColumn<any>[] = [
        {
            title: Lang.TTL_CONTRACT_NO,
            index: 'contract_no',
            render: (_, value) => <span>{value.contract_number || '-'}</span>,
            headerProps: {
                //className: Style.subcontractor,
            },
        },
        {
            title: Lang.TTL_ASSOCIATED_PRIME,
            index: 'associated_prime',
            render: (_, value) => <span>{value.PrimeName || '-'}</span>,
            headerProps: {
                //className: Style.subcontractor,
            },
        }, {
            title: Lang.TTL_EXCEPTION_STATUS,
            index: 'exception_status',
            render: (_, value) => <span>{value.status ? Lang.LBL_EXCEPTION_REMOVED : Lang.LBL_EXCEPTION_ADDED}</span>,
            headerProps: {
                //className: Style.subcontractor,
            },
        },
        {
            title: Lang.TTL_START_DATE,
            index: 'start_date',
            render: (_, value) => <span>{`${value?.startDate && value?.startDate != '-' ? moment.utc(value?.startDate).format('MM/DD/YYYY') : '-'}`}</span>,
            headerProps: {
                //className: Style.subcontractor,
            },
        },
        {
            title: Lang.TTL_END_DATE,
            index: 'end_date',
            render: (_, value) => (
                <span>{`${value?.endDate && value?.endDate != '-' ? moment.utc(value?.endDate).format('MM/DD/YYYY') : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.von,
            },
        },
        {
            title: Lang.TTL_DONE_BY,
            index: 'done_by',
            sortable: false,
            render: (_, value) => <span>{concatinateArrayWithSpace([value.firstName, value.lastName])===''?'-':concatinateArrayWithSpace([value.firstName, value.lastName])}</span>,
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: Lang.TTL_TIME_STAMP,
            index: 'timestamp',
            sortable: false,
            render: (_, value) => <span>{`${value?.loggedAt && value?.loggedAt != '-' ? moment.utc(value?.loggedAt).format('MM/DD/YYYY hh:mm A') : '-'}`}</span>,
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: Lang.TTL_EMAIL,
            index: 'email',
            sortable: false,
            render: (_, value) => <span>{!value.status && <i
                style={{
                    color: '#009BDA',
                    // fontWeight: 'bold',
                    fontStyle: 'normal',
                    cursor: 'pointer',
                }}
                onClick={() => handleOpenEmailView(value)}
            >{'Click to view Email'}</i>}</span>,
            headerProps: {
                //className: Style.prime,
            },
        }
    ];
    return (
        <ATMModal
            size="large"
            open={openAuditLogs}
            onClose={handleClose}
            closeOnDimmerClick={false}
        >
            <ATMModal.Header as="h5">
                {Lang.TTL_ADD_EXCEPTION_TO_CONTRACTS}
                <ATMIcon name="close" onClick={handleClose} style={{ color: '#606060', position: 'absolute', 'right': '0', top: '5px', cursor: 'pointer' }} />

            </ATMModal.Header>

            <ATMModal.Content>
                <ORGDataTable
                    celled={false}
                    columns={columns}
                    data={data}
                    loading={loadinglog}
                    sortable
                    // toolbar
                    // history
                    counter
                    // filters={true}
                    noDataText={Lang.MSG_NO_RECORDS_TO_DISPLAY}
                    onChange={fetchLogData}
                    total={totalRecord}
                    key={totalRecord}
                    rowsPerPageOptions={[10, 20, 25]}
                />
            </ATMModal.Content>
        </ATMModal>
    );
}

export default InvalidContractsAuditLogView;
